import { FormProvider, useForm } from "react-hook-form";
import { WritableControlContextProvider } from "../control/context";
import Dropdown from "../dropdown";
import FilterForm from "./filterForm";
import {
  FilterFormProps,
  FilterFormValues,
  FilterOperation,
  dateFilterOperations,
  numberFilterOperations,
  stringFilterOperations,
} from "./types";
import { getInitialFormValues } from "./utils";

export * from "./types";

interface FilterProps extends Omit<
  FilterFormProps,
  "filterOperations" | "close" | "maximum"
> {
  children: React.ReactNode;
  onSave: (values: FilterFormValues) => void;
  initialValue?: Omit<FilterFormValues, "operation"> & {
    operation: FilterOperation | undefined;
  };
  onDropdownOpen?: () => void;
  onDropdownClose?: () => void;
}

const Filter = (props: Readonly<FilterProps>) => {
  const { children, initialValue, variant, onDropdownOpen, onDropdownClose } =
    props;

  let filterOperations;
  if (variant.type === "number") {
    filterOperations = numberFilterOperations;
  } else if (variant.type === "datetime") {
    filterOperations = dateFilterOperations;
  } else {
    filterOperations = stringFilterOperations;
  }

  const methods = useForm<FilterFormValues>({
    mode: "all",
    defaultValues: getInitialFormValues(
      initialValue,
      filterOperations,
      variant.maxFilterNum,
    ),
  });

  return (
    <Dropdown
      menuMaxHeight={400}
      onOpen={onDropdownOpen}
      onClose={onDropdownClose}
    >
      <Dropdown.Toggle noStyle noIndicator>
        {children}
      </Dropdown.Toggle>
      <Dropdown.Panel className="max-w-[200px] min-w-[200px]! px-3 py-5">
        {({ close }) => (
          <WritableControlContextProvider>
            <FormProvider {...methods}>
              <FilterForm
                {...props}
                variant={variant}
                filterOperations={filterOperations}
                close={close}
              />
            </FormProvider>
          </WritableControlContextProvider>
        )}
      </Dropdown.Panel>
    </Dropdown>
  );
};

export default Filter;
